<template>
  <span>
    <!-- If is children resolution display parent name and number -->
    <div v-if="parentResolutionNumber && parentResolutionName && !isRevoteEventResolution">
      <span class="font-italic">{{ "Résolution n° " + parentResolutionNumber }}</span>
      <span class="font-italic">{{ " - " + parentResolutionName }}.</span>
      <!-- NOTE: Display parent details only for first children -->
      <div
        v-if="parentResolutionDescription && resolution.position == 1"
        class="text-br-line mt-2"
        v-html="parentResolutionDescription"
      ></div>
    </div>
    <div class="font-weight-bold">
      <span class="mr-1">{{ voteOrder }})</span>
      <span v-if="!parentResolutionNumber && !parentResolutionName">Résolution n°</span>
      <span v-else>Sous résolution n°</span>
      <span v-if="parentResolutionNumber">{{ parentResolutionNumber }}.</span
      >{{ resolution.resolution_number }}
    </div>
    <h5 class="my-0">{{ resolution.name }}</h5>
    <div v-if="resolution.majority_id" class="font-italic border-bottom border-3">
      <span v-if="resolution.majority_id != defaultSansVoteMajorityId">
        Majorité : {{ majorityName }}
      </span>
      <span v-if="resolution.majority_id == defaultSansVoteMajorityId">{{ majorityName }}</span>
      <span
        v-if="resolution.voting_category_id && resolution.majority_id != defaultSansVoteMajorityId"
      >
        &nbsp; - Clé de vote : {{ findVotingCategoryData(resolution.voting_category_id).name }}
      </span>
    </div>
    <div v-else class="text-danger">majorité non définie</div>
    <!-- eslint-disable vue/no-v-html -->
    <div class="mt-3 text-br-line" v-html="resolution.description"></div>
  </span>
</template>
<script>
import { defaultSansVoteMajorityId } from "@/constants/default.js";
export default {
  props: [
    "majorityName",
    "voteOrder",
    "childVoteOrder",
    "parentResolutionNumber",
    "resolution",
    "parentResolutionName",
    "parentResolutionDescription",
    "isRevoteEventResolution",
  ],
  data() {
    return {
      defaultSansVoteMajorityId,
    };
  },
};
</script>
